let messages = [];

export function init(msg) {
    messages = msg;
    Object.keys(msg).map((e) => sessionStorage.setItem(e, msg[e]));
}
export function getMessage(key) {
    let message = messages[key];
    return message !== undefined ? message : sessionStorage.getItem(key);
}


// WEBPACK FOOTER //
// ./src/MessageBundle.js